import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { chooseSelectedInquiryTypeSpecificValue } from 'shared/chooseSelectedInquiryTypeSpecificComponent';
import {
  SOURCE_DATA_SESSION_STORAGE_KEY,
  SPECIAL_LOAN_EMERGENCY_SERVICES_PARAM,
  UTM_DATA_SESSION_STORAGE_KEY,
} from 'utils/sessionStorage/keys';

const TRACKED_UTM_PARAMETERS = chooseSelectedInquiryTypeSpecificValue({
  [InquiryType.default]: [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'bfs_gclid',
  ] as const,
});

export type UtmData = Partial<Record<(typeof TRACKED_UTM_PARAMETERS)[number], string>>;

export const useCaptureQueryParams = () => {
  const { search } = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    sessionStorage.removeItem(UTM_DATA_SESSION_STORAGE_KEY);
    const utmParameters: UtmData = {};
    for (const key of TRACKED_UTM_PARAMETERS) {
      if (searchParams.has(key)) {
        utmParameters[key] = searchParams.get(key) as string;
      }
    }
    sessionStorage.setItem(UTM_DATA_SESSION_STORAGE_KEY, JSON.stringify(utmParameters));

    sessionStorage.removeItem(SOURCE_DATA_SESSION_STORAGE_KEY);
    if (searchParams.has(SPECIAL_LOAN_EMERGENCY_SERVICES_PARAM)) {
      sessionStorage.setItem(
        SOURCE_DATA_SESSION_STORAGE_KEY,
        JSON.stringify({ specialLoanEmergencyServices: true }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
